<template>
  <div class="overview-feedback-pictures">
    <template v-if="images.length">
      <div
        v-for="(image, index) in images"
        :key="index"
        class="overview-images-container"
      >
        <img :src="image.fileURL ? image.fileURL : image">
      </div>
    </template>
    <div v-else-if="isMobile">
      Pictures are not filled
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    images: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ...mapState('common', ['isMobile'])
  }
}
</script>

<style lang="sass">
.overview-images-container
  width: 100%
  height: 80%
  margin: 2rem 0
  overflow: auto
  display: flex
  flex-direction: column
  justify-content: center
.overview-feedback-pictures
  max-height: 500px
  overflow-y: auto
.overview-images-container img
  width: 100%
  height: 170px
  object-fit: cover
.overview-images-container img:not(:first-child)
  padding-top: 10px
.overview-images-container img:not(:last-child)
  padding-bottom: 10px
</style>
